module.exports = __webpack_public_path__ + "static/media/License-Plate-Game-2019-01-06-10_58_59.900a35ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/webShots/License-Plate-Game-2019-01-06-10_58_59.png
// module id = 394
// module chunks = 1